<template>
	<VMenu
		:distance="10"
		:skidding="135"
		:triggers="defaultTooltipTriggers"
		:delay="defaultMenuDelay"
		placement="right-end"
		no-auto-focus
	>
		<div
			class="px-4 py-3 text-white select-none flex flex-row justify-between items-center transition cursor-pointer group"
			:class="{ 'bg-primary': activeCompany.logoFile == null }"
		>
      <span
				v-if="!compactMode"
	      id="active-company-name"
	      class="font-medium w-full"
			>
        <span v-if="activeCompany.logoFile == null">
        {{ activeCompany.name }}
        </span>
        <img
					v-else-if="imgBlob"
	        :src="imgBlob"
	        class="w-full pl-2 pr-2 max-w-44 max-h-24 object-contain"
	        frameborder="0"
	        aria-label="Bedrijfslogo"
	        aria-description="Het logo van het actieve bedrijf"
	        :alt="activeCompany.logoFile.originalFileName"
				/>
      </span>
			<AppIcon
				icon="cog"
				class="group-hover:rotate-180 transition"
				:class="{ 'm-auto': compactMode, 'text-primary': activeCompany.logoFile !== null }"
			/>
		</div>
		<template #popper>
			<SettingsMenuContent v-bind="{ companies }"/>
		</template>
	</VMenu>
</template>

<script setup lang="ts">
import { CompanyWithoutNested, getActiveCompanyLogo, getUserCompanies } from "@q-food/q-food";
import { Menu as VMenu } from "floating-vue";
import { useAppSidebarStore } from "~stores/AppSidebar";
import { useUserStore } from "~stores/User";
import { ref } from "vue";
import { defaultMenuDelay, defaultTooltipTriggers } from "~utils/platformUtils.ts";

const companies = ref<CompanyWithoutNested[]>([]);
const { compactMode } = storeToRefs(useAppSidebarStore());
const { activeCompany } = storeToRefs(useUserStore());

onMounted(async () => {
	companies.value = await getUserCompanies();
	if (activeCompany.value.logoFile != null) {
		await getActiveCompanyLogo({
			responseType: "blob",
		}).then((response) => {
			imgBlob.value = URL.createObjectURL(response);
		});
	}
});

const imgBlob = ref<string>();
</script>

<style scoped></style>
